import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store';
import { ProductType } from 'slices/products';

// import

export interface CartType extends ProductType {
   amount: number;
}

const cartSlice = createSlice({
   name: 'cart',
   initialState: [] as CartType[],
   reducers: {
      addToCart: (state, action: PayloadAction<ProductType>) => {
         const productIndex = state.findIndex((product) => product.id === action.payload.id);

         if (productIndex !== -1) {
            state[productIndex].amount += 1;
         } else {
            state.push({ ...action.payload, amount: 1 });
         }
      },
      removeFromCart: (state, action: PayloadAction<number | string>) => {
         const productIndex = state.findIndex((product) => product.id === action.payload);

         if (productIndex !== -1) {
            return state.filter((i) => i.id !== action.payload);
         } else {
            console.log("This item isn't in your cart !");
         }

         return state;
      },
      updateFromCart: (state, action: PayloadAction<CartType>) => {
         const productIndex = state.findIndex((product) => product.id === action.payload.id);

         if (productIndex !== -1 && action.payload.amount >= 1) {
            state[productIndex].amount = action.payload.amount;
         } else if (productIndex !== -1 && action.payload.amount === 0) {
            return state.filter((i) => i.id !== action.payload.id);
         }

         return state;
      }
   }
});

export const { addToCart, removeFromCart, updateFromCart } = cartSlice.actions;
export const getCartSelector = (state: RootState) => state.cart;
export const geTotalCartPrice = (state: RootState) => state.cart.reduce((acc, next) => (acc += next.amount * next.price), 0);
export const geTotalCartAmount = (state: RootState) => state.cart.reduce((acc, next) => (acc += next.amount), 0);
export default cartSlice.reducer;
